import React, { useEffect, useState } from 'react';
import LayerComm from 'app/components/common/LayerComm';
import classNames from 'classnames/bind';
import useEnlog from 'app/hook/common/useEnlog';
import Button from 'app/components/common/Button';
import useSsrCookie from 'app/hook/common/useSsrCookie';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';
import { ONE_LINK_PREFIX } from 'app/constants/oneLink';
import styles from './LayerAfterPopup.module.scss';

const cx = classNames.bind(styles);

const LayerAfterPopup = ({ title, desc = '', btnText, delay = 2000, tel, onClose, onClick = undefined, typeText = '', dimmedClick = true }) => {
	const [view, setView] = useState(false);
	const { getCookie } = useSsrCookie();
	const userAgent = useSsrUserAgent();
	const { isApp } = userAgent();
	const pc_id = getCookie('PCID') || '';
	const afterCallOneLink = `${ONE_LINK_PREFIX}&deep_link_value=encarapp%3A%2F%2Findex.do%3F&af_sub1=encarapp%3A%2F%2Findex.do%3F&af_adset=Appdown_banner&af_ad=after_call&af_dp=encarapp%3A%2F%2F&af_sub2=${pc_id}`;
	const notWarrantyPopUp = typeText !== '보증한번더문의하기';
	// 엔로그
	const { enloggingJsonData } = useEnlog();
	useEffect(() => {
		const dataTalkViewSingle = {
			eventnamegroup: typeText,
		};
		enloggingJsonData({
			dataTalkViewSingle,
		});
	}, [enloggingJsonData, typeText]);

	useEffect(() => {
		setTimeout(() => {
			setView(true);
		}, delay);
	}, [delay]);

	const handleCloseClick = () => {
		onClose();
	};

	const handleClick = () => {
		if (onClick) {
			onClick();
		}
		onClose();
	};

	if (!view) return null;

	return (
		<LayerComm
			alignCenter
			useCloseBtn
			title={<span className={cx('tit')}>{title}</span>}
			onClose={handleCloseClick}
			data-enlog-dt-eventnamegroup={typeText}
			dimmedClick={dimmedClick}
		>
			{desc && <p className={cx('desc')}>{desc}</p>}
			<Button
				title={btnText}
				domType={tel ? 'anchor' : 'blankanchor'}
				to={tel || afterCallOneLink}
				onClick={handleClick}
				data-enlog-dt-eventnamegroup={typeText}
				data-enlog-dt-eventname={view && !isApp && notWarrantyPopUp ? '앱설치' : `${btnText}`}
			/>
		</LayerComm>
	);
};

export default LayerAfterPopup;
